import { render, staticRenderFns } from "./UnsupportBrowser.vue?vue&type=template&id=f645b674"
import script from "./UnsupportBrowser.vue?vue&type=script&lang=js"
export * from "./UnsupportBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports